import MovimientoShow from './MovimientoShow'
export {MovimientoShow}
export default MovimientoShow
